import React, { useEffect } from "react";
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import '../assets/styles/Main.scss';
import userImg from '../assets/images/userimg.jpg';
import { trackSocialClick, trackSectionView } from '../utils/mixpanel';

function Main() {
  useEffect(() => {
    trackSectionView('main');
  }, []);

  const handleSocialClick = (platform: string, url: string) => {
    trackSocialClick(platform, url);
  };

  return (
    <div className="container">
      <div className="about-section">
        <div className="image-wrapper">
        <img src={userImg} alt="Avatar" />
        </div>
        <div className="content">
          <div className="social_icons">
            <a 
              href="https://github.com/AmeerHamza112" 
              target="_blank" 
              rel="noreferrer"
              onClick={() => handleSocialClick('GitHub', 'https://github.com/AmeerHamza112')}
            >
              <GitHubIcon/>
            </a>
            <a 
              href="https://www.linkedin.com/in/ameer-hamza-39604214b/" 
              target="_blank" 
              rel="noreferrer"
              onClick={() => handleSocialClick('LinkedIn', 'https://www.linkedin.com/in/ameer-hamza-39604214b/')}
            >
              <LinkedInIcon/>
            </a>
          </div>
          <h1>Ameer Hamza</h1>
          <p>Senior Software Engineer</p>

          <div className="mobile_social_icons">
            <a 
              href="https://github.com/AmeerHamza112" 
              target="_blank" 
              rel="noreferrer"
              onClick={() => handleSocialClick('GitHub', 'https://github.com/AmeerHamza112')}
            >
              <GitHubIcon/>
            </a>
            <a 
              href="https://www.linkedin.com/in/ameer-hamza-39604214b/" 
              target="_blank" 
              rel="noreferrer"
              onClick={() => handleSocialClick('LinkedIn', 'https://www.linkedin.com/in/ameer-hamza-39604214b/')}
            >
              <LinkedInIcon/>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Main;